import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qy5weejrrs: FaireBrandEntity = {
  token: "b_qy5weejrrs",
  type: "brand",
  name: "HarperCollins Christian Publishing",
  avatarUrl:
    "https://cdn.faire.com/fastly/5facba82ade80ecd586f62b1ef7e7499ca2f86a8f1983aff5dd5bff77848a229.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2a44bc9e9b88f5a210b43b1ff859fceb7630a28354b199641c21c5b6e7734497.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5facba82ade80ecd586f62b1ef7e7499ca2f86a8f1983aff5dd5bff77848a229.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2a44bc9e9b88f5a210b43b1ff859fceb7630a28354b199641c21c5b6e7734497.jpeg",
  location: "Nashville, TN, USA",
  minimumOrderDollars: 274,
  rating: 4.8,
  reviewCount: 64,
  isInsider: true,
  description:
    "With nearly 300 years of publishing expertise, HarperCollins Christian Publishing (HCCP) is the leading provider of inspirational content.\n\nWe work alongside some of the world's most renowned inspirational voices like: Rick Warren, Max Lucado, Lysa TerKeurst, Shauna Niequist, Andy Stanley, Bob Goff, Jen Hatmaker, and Sarah Young. Plus, pop culture influencers such as Fixer Upper stars Chip and Joanna Gaines, former TODAY cohost Kathie Lee Gifford, personal finance expert Dave Ramsey, Olympic gold medalist Simone Biles, among other professional athletes, musicians, lifestyle personalities, bloggers, vloggers, and political figureheads also call HCCP their publishing home.\n\nRepresenting the works of over 2,000 authors and the world's largest Bible translations, HCCP is the most award-winning inspirational publisher in the industry, publishing bestselling content in every format, connecting words and people together wherever they live, work, or play.\n\nFrom bestsellers that have sold more than 40 million copies to authors whose words have started Christian movements around the world, HarperCollins Christian Publishing is committed to providing content for readers in any format and truly inspiring the world for a greater purpose.",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:03.185Z",
    importedBy: "entity-db-cli",
  },
};
